import { type ReactElement, type ReactNode } from 'react';
import styles from './style.module.scss';

interface ToolbarProperties {
  readonly children: ReactNode;
}

const Toolbar = ({ children }: ToolbarProperties): ReactElement => <div className={styles.container}>{children}</div>;

export default Toolbar;
